import { render, staticRenderFns } from "./page-number-pagination.vue?vue&type=template&id=86dab00a&scoped=true&"
import script from "./page-number-pagination.vue?vue&type=script&lang=js&"
export * from "./page-number-pagination.vue?vue&type=script&lang=js&"
import style0 from "./page-number-pagination.vue?vue&type=style&index=0&id=86dab00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dab00a",
  null
  
)

export default component.exports